
(function () {
  'use strict';

  var READY = 'data-hero-ready';
  var ACC_MS = 220;

  function dropAccEnd(body) {
    if (body._accDone) body.removeEventListener('transitionend', body._accDone);
    if (body._accTimer) clearTimeout(body._accTimer);
    body._accDone = body._accTimer = null;
  }

  function setAcc(acc, open) {
    var head = acc.querySelector('.p-hero__acc-head');
    var body = acc.querySelector('.p-hero__acc-body');
    if (!head || !body) return;
    if ((head.getAttribute('aria-expanded') === 'true') === open) return;

    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    acc.classList.toggle('is-open', open);

    dropAccEnd(body);

    var from = body.hidden ? 0 : body.getBoundingClientRect().height;
    body.style.transition = 'none';
    body.hidden = false;
    body.style.height = from + 'px';
    var to = open ? body.scrollHeight : 0;
    void body.offsetHeight; 

    function done(e) {

      if (e && (e.target !== body || e.propertyName !== 'height')) return;
      dropAccEnd(body);
      if (!open) body.hidden = true;
      body.style.transition = body.style.height = '';
    }

    if (Math.abs(to - from) < 1) { done(); return; } 
    body._accDone = done;
    body._accTimer = setTimeout(done, ACC_MS + 120);
    body.addEventListener('transitionend', done);
    body.style.transition = 'height ' + ACC_MS + 'ms ease';
    body.style.height = to + 'px';
  }

  function initAccordions(root) {
    root.querySelectorAll('.p-hero__acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var acc = head.closest('.p-hero__acc');
        if (!acc) return;
        var willOpen = head.getAttribute('aria-expanded') !== 'true';
        if (willOpen) {
          var group = acc.closest('.p-hero__accs') || root;
          group.querySelectorAll('.p-hero__acc.is-open').forEach(function (other) {
            if (other !== acc) setAcc(other, false);
          });
        }
        setAcc(acc, willOpen);
      });
    });
  }

  function initVariants(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('.p-hero__chip'));
    if (!chips.length) return;
    var input = root.querySelector('[data-variant-input]');

    var atcs = Array.prototype.slice.call(root.querySelectorAll('.p-hero__atc, .p-hero__sticky-atc'));

    var nowEls = Array.prototype.slice.call(root.querySelectorAll('.p-hero__price-now, .p-hero__atc-price, .p-hero__sticky-price'));
    var wasEl = root.querySelector('.p-hero__price-was');
    var lowestEl = root.querySelector('[data-lowest]');
    var lowestPrice = root.querySelector('[data-lowest-price]');
    var labelEls = Array.prototype.slice.call(root.querySelectorAll('[data-atc-text], [data-sticky-atc-text]'));
    var extras = Array.prototype.slice.call(root.querySelectorAll('.p-hero__atc-sep, .p-hero__atc-price, .p-hero__sticky-sep, .p-hero__sticky-price'));
    var bis = root.querySelector('.p-hero__bis');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.getAttribute('aria-disabled') === 'true') return;

        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });

        var id = chip.getAttribute('data-variant');
        if (input) input.value = id;
        var volEls = Array.prototype.slice.call(root.querySelectorAll('[data-fact-volume]'));
        volEls.forEach(function (el) { el.textContent = chip.getAttribute('data-volume') || (chip.textContent || '').trim() || el.textContent; });
        nowEls.forEach(function (el) { el.textContent = chip.getAttribute('data-price') || el.textContent; });
        if (wasEl) wasEl.textContent = chip.getAttribute('data-compare') || '';
        if (lowestEl && lowestPrice) {
          var was = chip.getAttribute('data-compare') || '';
          lowestPrice.textContent = was;
          lowestEl.hidden = !was;
        }

        var available = chip.getAttribute('data-available') !== 'false';
        atcs.forEach(function (b) { b.disabled = !available; });
        labelEls.forEach(function (el) {
          var btn = el.closest('.p-hero__atc, .p-hero__sticky-atc');
          var label = btn && btn.getAttribute(available ? 'data-label' : 'data-label-sold-out');
          if (label) el.textContent = label;
        });
        extras.forEach(function (el) { el.hidden = !available; });
        if (bis) bis.hidden = available;

        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {  }
      });
    });
  }

  function openMobileDefaults(root) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
    var acc = root.querySelector('.p-hero__acc[data-open-mobile]');
    if (!acc) return;
    var head = acc.querySelector('.p-hero__acc-head');
    var body = acc.querySelector('.p-hero__acc-body');
    if (!head || !body) return;
    head.setAttribute('aria-expanded', 'true');
    acc.classList.add('is-open');
    body.hidden = false;
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-hero-sticky]');
    var mainAtc = root.querySelector('.p-hero__buy .p-hero__atc');

    if (!sticky || !mainAtc) return;

    if (!('IntersectionObserver' in window)) return;

    sticky.hidden = false;

    document.body.classList.add('has-hero-sticky');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-shown', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(mainAtc);
  }

  function init(root) {
    if (!root || root.hasAttribute(READY)) return;
    root.setAttribute(READY, '');
    initAccordions(root);
    openMobileDefaults(root);
    initVariants(root);
    initSticky(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.p-hero').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-hero-sticky]')) {
      document.body.classList.remove('has-hero-sticky');
    }
  });
})();
